import FormattedMessage from 'I18n/components/FormattedMessage';
import { useEffect, useRef, useState } from 'react';
import UIButton from 'UIComponents/button/UIButton';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import UIModal from 'UIComponents/dialog/UIModal';
import UIFlex from 'UIComponents/layout/UIFlex';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import styled from 'styled-components';
import { tracker } from '../../../common/eventTracking/tracker';
import { handleSubmitSurveyResponses } from '../../../utils/trialFeatureSurveySubmit';
import { proDefaultSurveyResponseMap } from '../../SurveyResponses';
import { FeatureSurveyModalHeader } from './FeatureSurveyModalHeader';
import FeatureSurveyRow from './FeatureSurveyRow';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const BoldParagraph = styled.p.withConfig({
  displayName: "FeatureSurveyModal__BoldParagraph",
  componentId: "sc-1cvnyc2-0"
})(["font-weight:bold;"]);
const FeatureSurveyModal = ({
  apiName,
  setInitialSuccessModal,
  upgradeData
}) => {
  const lastApiName = useRef(apiName);
  const [allFeatures, setSelectedFeatures] = useState(proDefaultSurveyResponseMap[apiName]);
  const featureData = Object.values(allFeatures);
  const isDisabled = featureData.every(({
    isSelected
  }) => !isSelected);
  useEffect(() => {
    tracker.track('trialActivationInteraction', Object.assign({
      action: 'viewed pricing page survey modal'
    }, upgradeData));
    if (lastApiName.current !== apiName) {
      setSelectedFeatures(() => proDefaultSurveyResponseMap[apiName]);
      lastApiName.current = apiName;
    }
  }, [upgradeData, apiName]);
  const handleSubmitSelectedFeatures = async () => {
    await handleSubmitSurveyResponses(apiName, allFeatures, upgradeData);
    setInitialSuccessModal();
  };
  const handleSkip = () => {
    tracker.track('trialActivationInteraction', Object.assign({
      action: 'survey skipped'
    }, upgradeData));
    setInitialSuccessModal();
  };
  const handleSelectedFeatureChange = (featureKey, isSelected) => {
    const newSelectedFeatures = Object.assign({}, allFeatures, {
      [featureKey]: Object.assign({}, allFeatures[featureKey], {
        isSelected
      })
    });
    setSelectedFeatures(newSelectedFeatures);
  };
  const renderTwoRows = () => {
    const firstRowFeatureKeys = featureData.slice(0, 3);
    const secondRowFeatures = featureData.slice(3);
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(FeatureSurveyRow
      // className="m-bottom-5"
      , {
        features: firstRowFeatureKeys,
        onSelectionChange: handleSelectedFeatureChange
      }, firstRowFeatureKeys[0].featureKey), /*#__PURE__*/_jsx(FeatureSurveyRow, {
        features: secondRowFeatures,
        onSelectionChange: handleSelectedFeatureChange
      }, secondRowFeatures[0].featureKey)]
    });
  };
  const renderThreeRows = () => {
    const lastRow = featureData.pop();
    const firstRowFeatureKeys = featureData.slice(0, 3);
    const secondRowFeatures = featureData.slice(3);
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(FeatureSurveyRow, {
        features: firstRowFeatureKeys,
        onSelectionChange: handleSelectedFeatureChange
      }, firstRowFeatureKeys[0].featureKey), /*#__PURE__*/_jsx(FeatureSurveyRow, {
        features: secondRowFeatures,
        onSelectionChange: handleSelectedFeatureChange
      }, secondRowFeatures[0].featureKey), /*#__PURE__*/_jsx(FeatureSurveyRow, {
        features: [lastRow],
        onSelectionChange: handleSelectedFeatureChange
      }, lastRow.featureKey)]
    });
  };
  const renderFeatureRows = () => {
    // Render 3 rows of box buttons if there are 6 features for that api name.
    if (featureData.length > 6) {
      return renderThreeRows();
    }
    return renderTwoRows();
  };
  return /*#__PURE__*/_jsxs(UIModal, {
    use: "success",
    width: 750,
    size: "auto",
    centered: true,
    children: [/*#__PURE__*/_jsx(FeatureSurveyModalHeader, {}), /*#__PURE__*/_jsxs(UIDialogBody, {
      children: [/*#__PURE__*/_jsx(BoldParagraph, {
        className: "text-center",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "upgrades.trialFeatureSurvey.common.headline"
        })
      }), /*#__PURE__*/_jsx(UIFlex, {
        align: "center",
        direction: "column",
        gap: 32,
        className: "m-all-0 m-top-2",
        children: renderFeatureRows()
      })]
    }), /*#__PURE__*/_jsx(UIDialogFooter, {
      children: /*#__PURE__*/_jsxs(UIFlex, {
        align: "center",
        direction: "column",
        gap: 16,
        className: "m-all-0 m-top-2",
        children: [/*#__PURE__*/_jsx(UITooltip, {
          title: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "upgrades.trialFeatureSurvey.common.tooltip"
          }),
          disabled: !isDisabled,
          children: /*#__PURE__*/_jsx(UIButton, {
            use: "primary",
            onClick: () => {
              handleSubmitSelectedFeatures().catch(() => {});
            },
            disabled: isDisabled,
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "upgrades.trialFeatureSurvey.common.submitButton"
            })
          })
        }), /*#__PURE__*/_jsx(UIButton, {
          use: "link",
          onClick: handleSkip,
          className: "m-all-0",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "upgrades.trialFeatureSurvey.common.skipButton"
          })
        })]
      })
    })]
  });
};
export default FeatureSurveyModal;